import { Component } from '@angular/core';
import { RadiusDisplayService } from './Services/radius-display.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'DisplaySystem';
  mapAPIkeyReady= false;
  constructor( private radiusDisplayService: RadiusDisplayService, ){
    let first=0
    this.radiusDisplayService.showGoogleKeyMaps.subscribe(value=>{
      // console.log(value,"firssst  ")
     
        // console.log('step 33333333333')
        this.mapAPIkeyReady=true;
    
      first++;
    })
   
  }
}
